define('widgets/casumo/viewmodel',[
    'knockout'
], function (ko) {
    var Casumo = function(session, adventurers) {
        var self = this;

        self.casumo = ko.deferredComputed(function () {
            return session.getAssociatedPlayer().adventurer.casumo();
        });

        self.playerIdOrCasumoName = ko.observable().withFallback(session.id);

        self.adventurer = ko.deferredComputed(function() {
            return adventurers.getByPlayerIdOrCasumoName(self.playerIdOrCasumoName());
        });

        self.adventure = ko.deferredComputed(function() {
            return self.adventurer().getAdventure();
        });

        self.location = ko.deferredComputed(function() {
            return self.adventure().location;
        });

        self.travelling = ko.deferredComputed(function() {
            return self.location().travelling();
        });

    };

    return Casumo;
});

